import pegasus from "../../assets/scripts/global/01-pegasus";

document.addEventListener("alpine:init", () => {
    Alpine.data("navigation", () => ({
        scrolled: false,
        anyNavOpen: false,
        menuOpen: false,
        megaMenuOpen: null,
        searchOpen: false,
        ctaOpen: false,
        mobMenuOpen: false,
        mobSubMenu: null,
        hasTransparentBg: false,
        isMobile: true,
        ctaFormInitialized: false,
        ctaFormInitQueued: false,
        ctaFormInitAttempts: 0,
        ctaFormInitMaxAttempts: 12,
        init() {

            window.addEventListener("opencallback", () => this.openCta());

            this.hasTransparentBg = this.$refs.navBar.classList.contains(
                "bg-navbar-transparent"
            );

            pegasus.onResizeFinished(() => {
                this.isMobile = window.innerWidth <= 992;

                const page = document.getElementById("content");

                if (this.hasTransparentBg === false) {
                    if (this.isMobile) {
                        page.style.paddingTop = "80px";
                    } else {
                        page.style.paddingTop = "90px";
                    }
                }
            }, true);
        },
        openSearch() {
            this.closeAll();
            this.navZedTop();
            this.anyNavOpen = true;
            this.searchOpen = true;
            this.lockScroll();
        },
        openCta() {
            this.closeAll();
            this.navZedTop();
            this.anyNavOpen = true;
            this.ctaOpen = true;
            this.lockScroll();
            this.$nextTick(() => this.initCtaHubspotForm());
        },
        openMobNav() {
            this.closeAll();
            this.navZedTop();
            this.anyNavOpen = true;
            this.mobMenuOpen = true;
            this.lockScroll();
        },
        openNav() {
            this.closeAll();
            this.navZedTop();
            this.anyNavOpen = true;
            this.menuOpen = true;
            this.lockScroll();
        },
        closeAll() {
            document
                .getElementById("page-header")
                .style.removeProperty("z-index");
            this.anyNavOpen = false;
            this.menuOpen = false;
            this.megaMenuOpen = null;
            this.searchOpen = false;
            this.ctaOpen = false;
            this.mobMenuOpen = false;
            this.mobSubMenu = null;
            this.unlockScroll();
        },
        navZedTop() {
            document.getElementById("page-header").style.zIndex = "9999";
        },
        lockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
        },
        unlockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = "auto";
        },
        menuScrolling() {
            const navigationContainer =
                    document.getElementById("page-nav-container"),
                navigationHeight = navigationContainer.offsetHeight;

            this.scrolled = window.scrollY >= navigationHeight;

            this.hasTransparentBg = this.$refs.navBar.classList.contains(
                "bg-navbar-transparent"
            );
        },
        initCtaHubspotForm() {
            const container = document.getElementById("hbspt-form-cta");

            if (!container || this.ctaFormInitialized) {
                return;
            }

            const portalId = container.dataset.portalId;
            const formId = container.dataset.formId;
            const formInstanceId =
                container.dataset.formInstanceId || "nav-cta-form";

            if (!portalId || !formId) {
                return;
            }

            const renderForm = () => {
                if (
                    !window.hbspt ||
                    !window.hbspt.forms ||
                    typeof window.hbspt.forms.create !== "function"
                ) {
                    return false;
                }

                if (container.children.length > 0) {
                    this.ctaFormInitialized = true;
                    return true;
                }

                try {
                    window.hbspt.forms.create({
                        portalId,
                        formId,
                        target: "#hbspt-form-cta",
                        formInstanceId,
                        onFormReady: () => {
                            this.ctaFormInitialized = true;
                        },
                    });
                    return true;
                } catch (_error) {
                    return false;
                }
            };

            if (renderForm()) {
                this.retryCtaHubspotFormInit();
                return;
            }

            if (this.ctaFormInitQueued) {
                return;
            }

            this.ctaFormInitQueued = true;
            window.hsFormsOnReady = window.hsFormsOnReady || [];
            window.hsFormsOnReady.push(() => {
                this.ctaFormInitQueued = false;
                if (renderForm()) {
                    this.retryCtaHubspotFormInit();
                }
            });
        },
        retryCtaHubspotFormInit() {
            if (this.ctaFormInitialized) {
                this.ctaFormInitAttempts = 0;
                return;
            }

            if (this.ctaFormInitAttempts >= this.ctaFormInitMaxAttempts) {
                return;
            }

            this.ctaFormInitAttempts += 1;
            setTimeout(() => {
                if (this.ctaOpen && !this.ctaFormInitialized) {
                    this.initCtaHubspotForm();
                }
            }, 250);
        },
    }));
});
